// extracted by mini-css-extract-plugin
export default {"mainContainer":"FileUpload_mainContainer__f8keM","dashedBox":"FileUpload_dashedBox__WTjJX","fileInput":"FileUpload_fileInput__NrPPf","downloadLink":"FileUpload_downloadLink__WDTsC"};